import { transformAll } from './transform';
import schema from './schema';
import fields from './fields';
import table from './table';

const name = 'classrooms';
const path = 'classrooms';

const save = {
  name,
  path
};

export default {
  title: 'Classrooms',
  get: {
    name,
    path: [path, 'branches'],
    transform: transformAll,
    defaultValue: []
  },
  create: save,
  edit: { ...save, method: 'put', path: `${path}/:id` },
  delete: {
    name,
    path: `${path}/:id`
  },
  table,
  modal: {
    title: 'Save Classroom',
    fields,
    schema
  }
};
